const sortByTime =
  <K extends string>(key: K) =>
  <T extends Partial<Record<K, { time: string } | null>>>(a: T, b: T) => {
    const timeA = a[key]?.time ?? '';
    const timeB = b[key]?.time ?? '';

    return timeA.localeCompare(timeB);
  };

export default sortByTime;
